// extracted by css-extract-rspack-plugin
export default {"darkNavbarColorModeToggle":"darkNavbarColorModeToggle_Q0Zn"};